// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { IconComponent, ParagraphComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import {
  LANDING_OPTIONS_MODAL_FEATURES_DESCRIPTION_PROPS,
  LANDING_OPTIONS_MODAL_FEATURES_ICON_PROPS,
} from './constants/landing-options-modal-features.constants';
// Styles
import {
  LandingOptionsModalFeaturesComponentStyled,
  LandingOptionsModalFeaturesItemComponentStyled,
  LandingOptionsModalFeaturesListComponentStyled,
} from './landing-options-modal-features.component.styled';
// Types
import { LandingOptionsModalFeaturesComponentType } from './types/landing-options-modal-features.component.type';
import { LandingOptionsOptionComponentType } from 'components/landing-options/types/landing-options.component.type';

const LandingOptionsModalFeaturesComponent = <T,>({
  children,
  features,
  selectedMethod,
}: LandingOptionsModalFeaturesComponentType<T>): React.JSX.Element => (
  <LandingOptionsModalFeaturesComponentStyled>
    <LandingOptionsModalFeaturesListComponentStyled>
      {features[selectedMethod as string].map(
        ({
          description,
          icon,
        }: Pick<LandingOptionsOptionComponentType<T>, 'description' | 'icon'>) => (
          <LandingOptionsModalFeaturesItemComponentStyled key={description}>
            <IconComponent {...{ ...LANDING_OPTIONS_MODAL_FEATURES_ICON_PROPS, icon }} />
            <ParagraphComponent {...LANDING_OPTIONS_MODAL_FEATURES_DESCRIPTION_PROPS}>
              <FormattedMessage id={description} />
            </ParagraphComponent>
          </LandingOptionsModalFeaturesItemComponentStyled>
        )
      )}
      {children}
    </LandingOptionsModalFeaturesListComponentStyled>
  </LandingOptionsModalFeaturesComponentStyled>
);

export { LandingOptionsModalFeaturesComponent };
